import { Image as DatoImage } from "react-datocms";
import Image from "next/image";
import { Section, Container } from "@/components";
import { ImageType } from "@/types";
import { HorizontalRule } from "@narrative-software/narrative-web-ui";
import { Md } from "../Markdown/Md";

const workflowStepsFields = `
title
steps {
  ... on WorkflowStepRecord {
    title
    description
    maxDescriptionWidth
    image {
      responsiveImage {
        ...responsiveImageFragment
      }
    }
  }
  ... on WorkflowDividerRecord {
    kind
  }
}
`;

type WorkflowStep = {
  title: string;
  description: string;
  maxDescriptionWidth: number;
  image: ImageType;
};

type WorkflowDivider = {
  kind: string;
};

type WorkflowStepsType = {
  title: string;
  steps: Array<WorkflowStep | WorkflowDivider>;
};

const WorkflowSteps = ({ title, steps }: WorkflowStepsType) => {
  return (
    <Section className="bg-white overflow-x-hidden">
      <Container>
        <HorizontalRule bottomMargin />
        <h2 className="text-h2 font-semibold leading-compact text-center mb-14 lg:mb-16">{title}</h2>

        <div className="flex flex-col items-center lg:flex-row lg:items-start lg:justify-between">
          {steps?.map((step, index) =>
            "kind" in step ? (
              <div className="hidden mt-19 lg:flex" key={index}>
                {(step.kind === "Right Arrow" && (
                  <Image src="/images/arrow-right.svg" alt="" width="47" height="16" unoptimized />
                )) || <Image src="/images/arrow-left-right.svg" alt="" width="47" height="16" unoptimized />}
              </div>
            ) : (
              <div
                className="relative flex flex-col flex-1 items-center justify-center text-center mx-[-57px] my-3 lg:my-[-32px] first:-mt-0 first:lg:my-[-32px] max-w-[400px]"
                key={index}
              >
                <DatoImage data={step.image.responsiveImage} />
                <h3 className="mt-3 text-h3 font-semibold lg:mt-4">{step.title}</h3>
                <p className="mt-3 text-balance" style={{ maxWidth: step.maxDescriptionWidth }}>
                  <Md
                    replacers={{
                      strong: (chunk) => <span className="font-semibold">{chunk}</span>,
                    }}
                  >
                    {step.description}
                  </Md>
                </p>
              </div>
            ),
          )}
        </div>
      </Container>
    </Section>
  );
};

export type { WorkflowStepsType };
export { workflowStepsFields, WorkflowSteps };
